<template>
    <div class="our-mission__container d-flex">
        <div class="our-mission__img-container align-self-end">
            <img
                src="/images/landing-page/our-mission-2.svg"
                alt="our mission"
            />
        </div>
        <div class="our-mission__description d-flex flex-column">
            <div>
                <span>Our Mission</span>
            </div>
            <h4>Earning Yield Has Never Been <span>So Simple</span></h4>
            <p>
                Thetanuts Finance is creating the best-in-class products for
                users to maximize risk-adjusted yield generation in all market
                conditions with a well-designed and intuitive user experience
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    }
};
</script>

<style lang="scss" scoped>
.our-mission__container {
    background: #283841;
    padding-top: 60px;
    padding-right: 30px;
    padding-left: 30px;
    flex-direction: column;

    @media only screen and (min-width: 768px) {
        padding-left: 0px;
        flex-direction: row;
    }

    img {
        margin-left: -150px;
        margin-bottom: -40px;
        width: 140%;

        @media only screen and (min-width: 768px) {
            margin-left: -140px;
            margin-bottom: -45px;
            width: 100%;
        }

        @media only screen and (min-width: 1440px) {
            margin-left: 0px;
            margin-bottom: 0px;
            width: auto;
        }

        @media only screen and (min-width: 1920px) {
            width: 100%;
        }
    }
}
.our-mission__img-container {
    order: 2;

    @media only screen and (min-width: 768px) {
        order: 1;
    }

    @media only screen and (min-width: 1920px) {
        flex: 0 1 45%;
    }
}
.our-mission__description {
    // width: 530px;
    flex-basis: 30%;
    margin-left: 0px;
    margin-top: auto;
    margin-bottom: auto;
    order: 1;

    @media only screen and (min-width: 768px) {
        order: 2;
    }

    @media only screen and (min-width: 1440px) {
        margin-left: 150px;
    }

    div {
        span {
            font-family: Sofia Sans;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: 23px;
            letter-spacing: 0px;
            text-align: left;

            @media only screen and (min-width: 1440px) {
                font-size: 22px;
                line-height: 36px;
            }
        }

        &::after {
            content: "";
            height: 3px;
            background: white;
            width: 70px;
            margin-top: 5px;
            display: block;
        }
    }
    h4 {
        font-family: Sofia Sans;
        font-size: 23px;
        font-style: normal;
        font-weight: 700;
        line-height: 31px;
        letter-spacing: 0px;
        text-align: left;
        margin: 30px 0;

        @media only screen and (min-width: 1440px) {
            font-size: 36px;
            line-height: 48px;
        }

        span {
            background-image: linear-gradient(
                95.12deg,
                #1cc8c1 0%,
                #05feb1 0.01%,
                #d9ef46 28.64%,
                #ff843f 49.48%,
                #a2f9e4 73.96%,
                #05feb1 100%
            );
            -webkit-background-clip: text;
            background-clip: text;
            box-decoration-break: clone;
            -webkit-box-decoration-break: clone;
            color: transparent;

            background-size: 300%;
            background-position: -100%;

            animation: animatedText 5s infinite alternate-reverse;
        }
    }
    p {
        font-family: Inter;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        line-height: 23px;
        letter-spacing: 0px;
        text-align: left;

        @media only screen and (min-width: 1440px) {
            font-size: 24px;
            line-height: 36px;
        }
    }
}

@keyframes animatedText {
    to {
        background-position: 100%;
    }
}
</style>
